import React, { useState, Fragment, useEffect } from "react";
import { Table, TableHead, TableBody } from "component/common/Table/index";
import TextInput from "component/common/TextInput";
import Pagination from "component/common/Pagination";
import TransactionFilter from "./TransactionFilter";
import { useLocation, useHistory } from "react-router-dom";
import { Toast } from "utils/toast";
import queryString from "query-string";
import { getAllTransaction } from "service/Transaction";
import Loader from "component/common/Loader";

import styles from "./Transaction.module.scss";

const TransactionList = () => {
  const location = useLocation();

  const history = useHistory();

  const head = [
    "Item Code",
    "Product Name",
    "Buyer Name",
    "Received",
    "Shipping Charge",
    "Seller Name",
    "Paid",
    "Profit",
    "Type",
    "",
  ];

  let [transaction, setTransaction] = useState(null);

  let [activeIndex, setActiveIndex] = useState(null);

  let [totalPages, setTotalPages] = useState();

  const page = new URLSearchParams(location.search).get("page");

  const product = new URLSearchParams(location.search).get("product");

  const received = new URLSearchParams(location.search).get("received");

  const profit = new URLSearchParams(location.search).get("profit");

  const paid = new URLSearchParams(location.search).get("paid");

  const type = new URLSearchParams(location.search).get("type");

  const buyer = new URLSearchParams(location.search).get("buyer");

  const seller = new URLSearchParams(location.search).get("seller");

  const code = new URLSearchParams(location.search).get("code");

  useEffect(() => {
    getTransAction();
  }, [location.search]);

  const getTransAction = async () => {
    let params = {
      page: page != null ? page : 1,
      code: code,
      productName: product,
      buyerName: buyer,
      sellerName: seller,
      paymentReceived: received,
      profit: profit,
      paidToSeller: paid,
      type: type,
    };
    try {
      let response = await getAllTransaction(params);
      if (response.status == 200) {
        setTransaction(response.data.data.data);
        setTotalPages(response.data.data.pageMeta.totalPages);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggleAccordian = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const handlePageChange = (event) => {
    let params = queryString.stringify({
      code: code ? code : undefined,
      product: product ? product : undefined,
      buyer: buyer ? buyer : undefined,
      seller: seller ? seller : undefined,
      received: received ? received : undefined,
      profit: profit ? profit : undefined,
      paid: paid ? paid : undefined,
      type: type ? type : undefined,
    });
    if (params == "") {
      history.push(`/admin/transactions/list?page=${event}`);
    } else {
      history.push(`/admin/transactions/list?${params}&page=${event}`);
    }
  };

  if (transaction == null) return <Loader />;

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-12">
          <div className={styles.transaction_title}>
            <b>Transactions</b>
          </div>
        </div>
      </div>
      <Table>
        <TableHead className={styles.transaction_head} head={head} />
        <TransactionFilter />
        <TableBody>
          {transaction.length != 0 ? (
            transaction.map((list, index) => {
              return (
                <Fragment key={index}>
                  <tr key={index} className={styles.transaction_body}>
                    <td>{list.itemCode}</td>
                    <td>{list.productName}</td>
                    <td>{list.fullname}</td>
                    <td>
                      {Number(list.received).toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency: "INR",
                      })}
                    </td>
                    <td>
                      {Number(list.shippingCharges).toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency: "INR",
                      })}
                    </td>
                    <td>{list.sellerName}</td>
                    <td>
                      {Number(list.paidToSeller).toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency: "INR",
                      })}
                    </td>
                    <td>
                      {Number(list.profit).toLocaleString("en-IN", {
                        maximumFractionDigits: 2,
                        style: "currency",
                        currency: "INR",
                      })}
                    </td>
                    <td>{list.type}</td>
                    <td
                      style={{
                        transform:
                          activeIndex === index ? "rotate(180deg)" : "none",
                      }}
                    >
                      <i
                        className="icon-drop-down"
                        onClick={() => toggleAccordian(index)}
                      ></i>
                    </td>
                  </tr>
                  <tr
                    style={{
                      border:
                        activeIndex === index ? "1px solid #C4C4C4" : "none",
                    }}
                  >
                    <td colSpan="10" style={{ padding: "0px" }}>
                      <div
                        className="table-accordian"
                        style={{
                          maxHeight: activeIndex === index ? "500px" : "0px",
                        }}
                      >
                        <div className="row" style={{ padding: "20px 60px" }}>
                          <div className="col-md-3">
                            <div style={{ marginBottom: "20px" }}>
                              <TextInput
                                label="Seller Name"
                                value={list.sellerName}
                                disabled={true}
                              />
                            </div>
                            <div style={{ marginBottom: "20px" }}>
                              <TextInput
                                label="Amount Paid to Seller"
                                value={Number(list.paidToSeller).toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 2,
                                    style: "currency",
                                    currency: "INR",
                                  }
                                )}
                                disabled={true}
                              />
                            </div>
                            <div style={{ marginBottom: "20px" }}>
                              <TextInput
                                label="Date of Payment Transferred"
                                type="date"
                                value={new Date(list.paymentDate)
                                  .toISOString()
                                  .substr(0, 10)}
                                disabled={true}
                              />
                            </div>
                            <div style={{ marginBottom: "20px" }}>
                              <TextInput
                                label="Seller Account Details"
                                value={list.sellerAccount}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div style={{ marginBottom: "20px" }}>
                              <TextInput
                                label="Buyer"
                                value={list.fullname}
                                disabled={true}
                              />
                            </div>
                            <div style={{ marginBottom: "20px" }}>
                              <TextInput
                                label="Amount Received from Buyer"
                                value={Number(list.received).toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 2,
                                    style: "currency",
                                    currency: "INR",
                                  }
                                )}
                                disabled={true}
                              />
                            </div>
                            <div style={{ marginBottom: "20px" }}>
                              <TextInput
                                label="Date of Payment Received"
                                type="date"
                                value={new Date(list.paymentReceived)
                                  .toISOString()
                                  .substr(0, 10)}
                                disabled={true}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className={styles.transaction_invoice}>
                              <img src="https://cdn.vertex42.com/WordTemplates/images/word-invoice-template.png"></img>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="10" className="no-record">
                No Records Found
              </td>
            </tr>
          )}
        </TableBody>
      </Table>
      {totalPages > 1 && (
        <Pagination
          totalPages={totalPages}
          activePage={page != null ? page : 1}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default TransactionList;
